<template>
  <div>
    <div class="botones-container " v-if="esOperadorServ">
      <v-btn class="stats-button common-botton" dark @click="verAsignadas">
        Asignadas ({{ counts.asignadas }})
      </v-btn>

      <v-btn class="stats-button common-botton" dark @click="verTramite">
        En trámite ({{ counts.enTramite }})
      </v-btn>
      <v-btn class="stats-button common-botton" dark @click="verPendientesInf">
        Pendientes de información ({{ counts.pendientesInf }})
      </v-btn>
      <v-btn class="stats-button common-botton" dark @click="verAtencionManual">
        Atención manual ({{ counts.atencionManual }})
      </v-btn>

      <v-btn class="stats-button common-botton" dark @click="verPendientes">
        Pendientes de autorización ({{ counts.pendientes }})
      </v-btn>
    </div>
    <v-expansion-panels elevation="0">
      <v-expansion-panel elevation="0">
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.id"
                  label="No. Solicitud"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.poliza"
                  label="Certificado"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>

              <v-col cols="12" md="3">
                <v-menu
                  v-model="menuFecha"
                  :close-on-content-click="false"
                  :max-width="300"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      :value="datesSelectedString"
                      label="Rango de fechas"
                      outlined
                      dense
                      readonly
                      prepend-inner-icon="mdi-calendar"
                      background-color="white"
                      color="#b11f1f"
                      v-on="on"
                      v-bind="attrs"
                    />
                  </template>
                  <v-card :width="300">
                    <v-date-picker
                      v-model="form.fecha_creacion"
                      range
                      locale="es"
                      selected-items-text="2 seleccionadas"
                      :width="300"
                    ></v-date-picker>
                    <v-card-actions>
                      <v-btn small text @click="form.rango_fechas = []"
                        >Limpiar</v-btn
                      >
                      <v-spacer></v-spacer>
                      <v-btn
                        small
                        text
                        color="primary"
                        @click="menuFecha = false"
                        >Listo</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.nombre"
                  label="Nombre"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoPaterno"
                  label="Apellido Paterno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.apellidoMaterno"
                  label="Apellido Materno"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.rfc"
                  label="RFC"
                  outlined
                  dense
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.celular"
                  label="Teléfono"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="form.email"
                  label="Correo electrónico"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  background-color="white"
                  color="#b11f1f"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div class="pt-5">
      <v-row>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.status"
            :items="statuslist"
            item-value="id"
            item-text="nombre"
            label="Estatus"
            color="#b11f1f"
            outlined
            background-color="white"
            dense
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.tipo"
            :items="tipoList"
            label="Tipo"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>

        <v-col cols="6" md="2">
          <v-select
            v-model="form.categoria"
            :items="categorias"
            label="Categoria"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>
        <v-col cols="6" md="2">
          <v-select
            v-model="form.operador_id"
            :items="operadores"
            item-text="nombreCompleto"
            item-value="id"
            label="Operador"
            outlined
            color="#b11f1f"
            background-color="white"
            dense
          />
        </v-col>

        <v-spacer></v-spacer>

        <v-col cols="12" md="3" class="d-flex justify-end">
          <v-btn
            dark
            outlined
            color="#b11f1f"
            rounded
            class="mr-2"
            min-width="120"
            @click="clearForm()"
          >
            Limpiar
          </v-btn>
          <v-btn
            class="common-botton"
            dark
            min-width="120"
            :disabled="!isFormValid || !minimoUnCampoLleno"
            :loading="loading"
            @click="updateSearch"
          >
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mainAxios } from "@/mainAxios";
import moment from "moment";
import { getSolicitudesCount } from "@/services/solicitudService";
import { getAllCampaniasPostVenta } from "@/services/campaniasPostventa";

export default {
  props: {
    currentFilters: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        id: "",
        certificado: "",
        producto_id: "",
        fecha_creacion: [],
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        rfc: "",
        celular: "",
        email: "",
        tipo: "",
        status: "",
        ramo: "",
        operador_id: "",
        tarjeta: "",
      },
      producto_id: "",
      isFormValid: true,
      error: "",
      menuFecha: false,
      rango_fechas: [],
      tipoList: ["Redención Beneficio", "Redención Asistencia"],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      categorias: [
        "Redención Normal",
        "Redención sin Emisión",
        "Redención por Excepción",
      ],
      statuslist: [],
      productos_aseguradora: [],
      usuarios: [],
      counts: {
        asignadas: 0,
        enTramite: 0,
        pendientesInf: 0,
        pendientes: 0,
        atencionManual: 0,
      },
    };
  },
  computed: {
    operadores() {
      if (!this.usuarios || this.usuarios.length === 0) return [];

      const op = this.usuarios.filter(
        (usuario) =>
          usuario.rol === "OPERADOR" || usuario.rol === "OPERADORASIST"
      );

      return op;
    },
    datesSelectedString() {
      if (this.form.fecha_creacion.length > 1)
        return `${this.formatDate(
          this.form.fecha_creacion[0]
        )} a ${this.formatDate(this.form.fecha_creacion[1])}`;
      return "";
    },

    minimoUnCampoLleno() {
      return Object.keys(this.form).some((key) => {
        const value = this.form[key];

        if (Array.isArray(value)) {
          return value.length > 0;
        }

        return value !== "" && value !== null && value !== undefined;
      });
    },
    esOperadorServ() {
      return ["OPERADORSERVICIOS", "ADMIN"].includes(this.rol);
    },
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      //   this.form.status = 0;
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    formatedDates() {
      let inicioUTC = null;
      let finUTC = null;
      if (this.form.fecha_creacion.length > 0) {
        if (this.form.fecha_creacion[1]) {
          inicioUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          finUTC = moment
            .utc(this.form.fecha_creacion[1])
            .subtract(6, "hours")
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD HH:mm:ss");
        } else {
          inicioUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
          finUTC = moment
            .utc(this.form.fecha_creacion[0])
            .subtract(6, "hours")
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD HH:mm:ss");
        }
        return [inicioUTC, finUTC];
      }
      return null;
    },

    getProductosAseguradora() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get("v1/producto/productosAseguradora", config)
        .then((response) => {
          this.productos_aseguradora = response.data.data.productos;
        });
    },

    getAgentes() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      this.usuarios = [];
      mainAxios.get("/v1/agente/list", config).then(({ data }) => {
        this.usuarios = data.map((e) => ({
          correo: e.correo,
          nombreCompleto: e.nombreCompleto,
          id: e.id,
          uuid: e.uuid,
          rol: e.roles?.[0]?.rol || null,
          roles: e.roles || [],
        }));
      });
    },

    getStatus() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios.get("/v1/solicitud/status/lista", config).then((resp) => {
        this.statuslist = resp.data.data.statusSolicitud;
      });
    },

    updateSearch() {
      if (!this.isFormValid || !this.minimoUnCampoLleno) return;
      let payload = {};
      Object.keys(this.form).forEach((key) => {
        const value = this.form[key];

        // campos vacíos no
        if (value === "" || value === null || value === undefined) return;

        // arreglos vacíos
        if (Array.isArray(value) && value.length === 0) return;

        payload[key] = value;
      });

      this.$emit("searchUpdated", payload);
    },

    setCurrent() {
      this.clearForm();
      this.form = { ...this.form, ...this.currentFilters };
    },
    async getCountSolicitudes() {
      const data = await getSolicitudesCount();
      // const data = res.data;
      const asignadas = data.find((item) => item.status === 10)?.cantidad || 0;
      const enTramite = data.find((item) => item.status === 2)?.cantidad || 0;
      const pendientesInf =
        data.find((item) => item.status === 11)?.cantidad || 0;
      const atencionManual =
        data.find((item) => item.status === 7)?.cantidad || 0;

      const pendientes =
        data.find((item) => [9].includes(item.status))?.cantidad || 0;

      this.counts = {
        asignadas,
        enTramite,
        pendientesInf,
        pendientes,
        atencionManual,
      };
    },

    async loadCampanias() {
      try {
        const res = await getAllCampaniasPostVenta();
        this.campaniasRaw = res || [];
        const tiposSolicitud = [
          ...new Set(this.campaniasRaw.map((c) => c.tipificacion)),
        ];

        const categoriasList = [
          ...new Set(this.campaniasRaw.map((c) => c.campania)),
        ];

        const catFromServer = new Set([...this.categorias, ...categoriasList]);
        this.categorias = [...catFromServer];

        const typesFromServer = new Set([...this.tipoList, ...tiposSolicitud]);

        this.tipoList = [...typesFromServer];
      } catch (error) {
        console.error("Error al cargar campañas:", error);
      }
    },

    aplicarFiltroPorEstado(status) {
      const filter = { status };

      // Solo se agrega el filtro por agente loggeado si no son status 7 ni 9
      if (status !== 7 && status !== 9) {
        filter.self_operador = "";
      }
      this.$emit("searchUpdated", filter);
    },
    verAsignadas() {
      this.aplicarFiltroPorEstado(10);
    },
    verTramite() {
      this.aplicarFiltroPorEstado(2);
    },
    verPendientesInf() {
      this.aplicarFiltroPorEstado(11);
    },
    verPendientes() {
      this.aplicarFiltroPorEstado(9);
    },
    verAtencionManual() {
      this.aplicarFiltroPorEstado(7);
    },
  },

  mounted() {
    this.getCountSolicitudes();
    this.getProductosAseguradora();
    this.getAgentes();
    this.getStatus();
    this.loadCampanias();
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}
.v-expansion-panels {
  z-index: auto !important;
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #fcf2f2;
}
.v-expansion-panel-header {
  background-color: #fcf2f2;
  border-radius: 20px !important;
}
.botones-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stats-button {
  width: 300px;
  height: 40px !important;
  font-size: small;
  font-weight: bold;
  margin-top: 10px;
}
</style>
